import { render, staticRenderFns } from "./BulkCaseGroupSet.vue?vue&type=template&id=efbe4db8&"
import script from "./BulkCaseGroupSet.vue?vue&type=script&lang=js&"
export * from "./BulkCaseGroupSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports